import { useEffect, useState } from 'react';

export const SCREEN_SIZES = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
    xxl: 'xxl',
};

export const CHUNKS_BY_SCREEN_SIZE = {
    [SCREEN_SIZES.sm]: 1,
    [SCREEN_SIZES.md]: 2,
    [SCREEN_SIZES.lg]: 2,
    [SCREEN_SIZES.xl]: 3,
    [SCREEN_SIZES.xxl]: 4,
};

export const getItemsPerRow = (screenSize) => {
    return CHUNKS_BY_SCREEN_SIZE[screenSize] || CHUNKS_BY_SCREEN_SIZE[SCREEN_SIZES.sm]
}

function getScreenSize() {
    if (typeof window === 'undefined') {
        return SCREEN_SIZES.xl;
    }
    const windowWidth = window.innerWidth || document.body.clientWidth;
    if (windowWidth < 576) return SCREEN_SIZES.sm;
    if (windowWidth < 768) return SCREEN_SIZES.md;
    if (windowWidth < 992) return SCREEN_SIZES.lg;
    if (windowWidth < 1540) return SCREEN_SIZES.xl;
    return SCREEN_SIZES.xxl;
}
export const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState(getScreenSize());
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(getScreenSize());
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return screenSize;
};
